import { useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { TrendingDown, TrendingUp } from "lucide-react";

const PARAMS = [["PESO", "Peso", "kg"], ["PETTO", "Petto", "cm"], ["VITA", "Vita", "cm"], ["FIANCHI", "Fianchi", "cm"], ["GAMBE", "Gambe", "cm"], ["BRACCIA", "Braccia", "cm"]];
const short = (d) => new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short" });

export default function PortalProgress({ history }) {
  const [k, setK] = useState("PESO");
  const [, label, unit] = PARAMS.find((p) => p[0] === k);
  const pts = history.filter((h) => h.values[k] != null).map((h) => ({ date: h.date, v: h.values[k] }));
  const diff = pts.length > 1 ? Math.round((pts[pts.length - 1].v - pts[0].v) * 10) / 10 : null;
  return (
    <div className="space-y-3 rounded-2xl border border-[#d4af37]/25 bg-[#0f1d3a]/80 p-4" data-testid="portal-progress">
      <div className="flex items-center justify-between">
        <span className="font-display text-sm font-bold tracking-wider text-[#f1d78a]">I TUOI PROGRESSI</span>
        {diff !== null && (
          <span className={`inline-flex items-center gap-1 rounded-lg px-2 py-0.5 font-mono-num text-xs font-bold ${diff <= 0 ? "bg-emerald-400/15 text-emerald-300" : "bg-[#d4af37]/15 text-[#f1d78a]"}`} data-testid="portal-progress-diff">
            {diff <= 0 ? <TrendingDown className="h-3.5 w-3.5" /> : <TrendingUp className="h-3.5 w-3.5" />}{diff > 0 ? "+" : ""}{diff} {unit} dall'inizio
          </span>
        )}
      </div>
      <div className="flex gap-1.5 overflow-x-auto pb-1">
        {PARAMS.map(([id, l]) => (
          <button key={id} onClick={() => setK(id)} className={`shrink-0 rounded-full px-3 py-1 text-xs font-semibold ${k === id ? "bg-gradient-to-r from-[#d4af37] to-[#f1d78a] text-[#0a1428]" : "border border-[#d4af37]/25 text-slate-300"}`} data-testid={`portal-progress-param-${id}`}>{l}</button>
        ))}
      </div>
      {pts.length === 0 ? (
        <div className="py-8 text-center text-xs text-slate-400" data-testid="portal-progress-empty">Nessuna misura di {label.toLowerCase()} confermata dal coach.</div>
      ) : (
        <div className="h-48" data-testid="portal-progress-chart">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={pts} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
              <CartesianGrid stroke="rgba(212,175,55,.08)" vertical={false} />
              <XAxis dataKey="date" tickFormatter={short} tick={{ fill: "#94a3b8", fontSize: 10 }} axisLine={false} tickLine={false} />
              <YAxis domain={["dataMin - 2", "dataMax + 2"]} tick={{ fill: "#94a3b8", fontSize: 10 }} axisLine={false} tickLine={false} allowDecimals={false} />
              <Tooltip contentStyle={{ background: "#07122a", border: "1px solid rgba(212,175,55,.4)", borderRadius: 12, fontSize: 12 }} labelFormatter={short} formatter={(v) => [`${v} ${unit}`, label]} />
              <Line type="monotone" dataKey="v" stroke="#d4af37" strokeWidth={2.5} dot={{ r: 4, fill: "#f1d78a", stroke: "#d4af37" }} activeDot={{ r: 6 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
